import NavBar from "../components/NavBar/NavBar"
import Footer from "../components/Footer/Footer"
import Spinner from "../components/Spinner/Spinner"
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faTrash, faVanShuttle } from "@fortawesome/free-solid-svg-icons";
import URLPage from "../endPoints/endpoints";
import axios from "axios";

import getVanlist from "../utilities/getVanList";
import * as listVansActions from "../redux/listVans/listVansActions"
import ListVansBody from "../components/ListsVansBody/ListsVansBody";

function Dashboard(params) {
   window.scrollTo({ top: 0, behavior: "smooth" });
    const dispatch = useDispatch();
    const navBar = useSelector(state => state.navbar.navbar);
    const user  = useSelector(state => state.us.current?.token);
    const page =  useSelector(state => state.vansList.vansPage);
    const navigate = useNavigate();
     const waitList = async() => {
   await getVanlist(0, 10, user)
  .then(res => {
    dispatch(listVansActions.setVansLists(res.data)); 
  })
  .catch(err => {
    console.error(err);
  });

  
   
 }

    useEffect(() => {
       
       if(!user) {
        navigate('/');
        window.location.reload();
        return 
        }else {
         axios.get(`${URLPage}/api/users/validate-user`, {
         headers: 
       {
        'x-token': user
        }
   })
   .then(res => {
    waitList()
    
  })
  .catch(err => {
   navigate('/');
   window.location.reload();
  });



   }
     
    }, []);
    
  
    return <>
          <div className="page-container">
        
          <div className={navBar ? '' : ''}>
           <NavBar title='Dashboard'/>
          </div>
            
          {/* <Spinner/> */}
         <div className="content-wrap">
          <div className="d-flex justify-content-around">
                   <div >
                    <h3 className="mb-0">REPORTS:</h3>
                   </div>
                   <div>

                    <Link to="/add-report"  >
                       <button type="button" className="btn btn-primary btn-lg">
                      Add Report <FontAwesomeIcon  icon={faPlusCircle} size='1x' />
                     </button>
                        
                    </Link>
                   </div>                     
          </div>

          <ListVansBody></ListVansBody>

        </div>   

          <div className={navBar ? '' : ''} >
           <Footer/>
          </div>
          
          </div>
           </> 
}

export default Dashboard